import React, { useState, useRef, useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import gsap from 'gsap'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Mousewheel } from 'swiper'
import { Autoplay } from 'swiper'
import projects from '../data/project'
import ProjectSlide from './ProjectSlide'

import 'swiper/css'
import 'swiper/css/mousewheel'

SwiperCore.use([Mousewheel])

function ProjectSlider({ childrenObj }) {
    const [title, setTitle] = useState('')
    const slider = useRef(null)
    const line = useRef(null)
    const lineAnimation = (target) => {
        const tl = gsap.timeline({ ease: 'power2.out' })
        tl.to(target, {
            opacity: 0,
            width: 0
        })
        tl.to(target, {
            opacity: 1,
            width: '16rem'
        }, '>0.2')
    }

    const hoverStatusHandler = (status) => {
        const parent = slider.current.parentElement

        parent.dataset.onHover = status
    }

    useEffect(() => {
        hoverStatusHandler(false)
    }, [])

    return (
        <>
            <div className="project-name" currecnt>
                <AnimatePresence mode="wait">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ type: 'tween' }}
                        key={title}
                        className="left-text">
                        <h1>{title}</h1>
                    </motion.div>
                </AnimatePresence>
                <div className="line-wrapper">
                    <hr className='line' ref={line} />
                </div>
            </div>
            {/* <div className="swiper-toggle-scroll-area"
            onMouseEnter={() => {
                console.log('masuk')
            }} 
            onMouseLeave={() => {
                console.log('out')
            }}
            ></div> */}
            <Swiper
                modules={[Autoplay]}
                spaceBetween={-180}
                direction="vertical"
                slidesPerView="auto"
                mousewheel={true}
                loop={true}
                speed={1000}
                autoplay={{ delay: 2500, reverseDirection: true, disableOnInteraction: false, pauseOnMouseEnter: true }}
                className="project-slide-container"
                onSlideChange={(swiper) => {
                    lineAnimation(line.current)
                    swiper.slides.forEach(slide => {
                        if (slide.dataset.swiperSlideIndex == swiper.realIndex) {
                            setTitle(slide.firstChild.dataset.title)
                        }
                    })
                }}
            >
                {projects.map(obj => {
                    return (
                        <SwiperSlide
                            onMouseEnter={() => {
                                hoverStatusHandler(true)
                            }}
                            onMouseLeave={() => {
                                hoverStatusHandler(false)
                            }}
                            ref={slider}
                            key={obj.project}>
                            <ProjectSlide data={obj} onClick={() => {
                                childrenObj(obj)
                            }} />
                        </SwiperSlide>
                    )
                })}
            </Swiper >
        </>
    )
}

export default ProjectSlider